<template>
  <div>
    <!-- 头部 -->
    <top></top>
    <div class="main">
      <navMenu :active="active"></navMenu>
      <div class="content">
        <div class="go-back" @click="goBack">返回</div>
        <div class="btn_box">
          <div class="main-title">发票管理</div>
            <button class="btn search-btn" @click="invoiceAdd">新建</button>
        </div>
        <div class="invitate-wrap">
          <!-- 列表 -->
          <div class="invitation-table">
            <el-table
              :data="tableData"
              style="width: 100%"
              :header-cell-style="{ background: '#EDF1F7', color: '#333' }"
            >
              <el-table-column label="抬头类型">
                <template slot-scope="scope">
                  <div>
                    {{
                      scope.row.header_type == 1
                        ? "企业单位"
                        : "个人／非企业单位"
                    }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="header" label="发票抬头名称">
              </el-table-column>
              <el-table-column prop="identification_code" label="纳税人识别号">
              </el-table-column>
              <!-- <el-table-column prop="address" label="单位地址">
              </el-table-column>
              <el-table-column prop="phone" label="单位电话"> </el-table-column> -->
              <el-table-column prop="email" label="邮箱"></el-table-column>
              <el-table-column fixed="right" label="操作" width="180">
                <template v-slot="scope">
                  <el-button
                    @click.native.prevent="handleEdit(scope.row.id)"
                    type="text"
                  >
                    修改
                  </el-button>
                  <el-button
                    @click.native.prevent="deleteRow(scope.$index, scope.row)"
                    type="text"
                    style="color: red"
                  >
                    删除
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div class="paginationbox">
          <el-pagination
            class="pagination"
            v-if="total > 0"
            background
            @current-change="handleCurrentChange"
            :current-page.sync="page"
            :page-size="pagesize"
            layout="total, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  invoiceHeaderLists,
  delInvoiceHeader,
} from "@/api/api";
import top from "../components/top.vue"; //头部
import navMenu from "../components/navMenu.vue"; //左侧步骤条

export default {
  components: { top, navMenu },
  name: "InvoiceManage",
  data() {
    return {
      type: JSON.parse(localStorage.getItem("userdata")).type,
      loading: false,
      active: 1,
      total: 0,
      tableData: [],
      currentPage: 1,
      page: 1,
      pagesize: 10,
      mark: "",
    };
  },
  mounted() {
    let stepMenuList = JSON.parse(localStorage.getItem("menu"));
    this.stepMenuList = stepMenuList;
    var index = stepMenuList.findIndex(function (item) {
      return item.link_url == "/PaymentManagement";
    });
    this.active = index;
    this.page = 1;
    this.mark = this.$route.query.mark;
    // 获取列表
    this.getList(this.page);
  },
  created() {},
  methods: {
    //新增
    invoiceAdd(data) {
      if(this.total>=20){
        this.$message.warning('发票抬头最多可新增20条');
      }else {
        this.$router.push({
          path: "/invoiceDetails"
        });
      }

    },
    //24.11.23 编辑 dxm
    handleEdit(id) {
      this.$router.push({
        path: "/invoiceDetails",
        query: {
          id
        },
      });
    },
    //24.11.23 获取列表 dxm
    getList(page) {
      let data = this.$qs.stringify({
        page_size: this.pagesize,
        page_no: page,
        type:this.type
      });
      this.loading = true;
      invoiceHeaderLists(data)
        .then((res) => {
          if (res.code == 1) {
            this.loading = false;
            let { data } = res;
            this.tableData = data.lists;
            this.total = data.count;
          } else {
            this.$message.warning(res.data);
          }
        })
        .catch((err) => {
          if (err.response.data.code != 401) {
            this.$message.warning(err.response.data.data);
          }
        });
    },

    // 返回
    goBack() {
      this.$router.back();
    },
    // 删除
    deleteRow(index, row) {
      this.$alert(`确定要删除吗？`, "", {
        confirmButtonText: "确定",
        callback: (action) => {
          if (action == "confirm") {
            delInvoiceHeader({ id: row.id })
              .then((res) => {
                if (res.code == 1) {
                  this.tableData.splice(index, 1);
                  this.totals = this.totals - 1;
                  this.$message.success(res.msg);
                }
              })
              .catch((err) => {
                console.log(err, "===err");
              });
          }
        },
      });
    },
    // 分页相关
    handleCurrentChange(val) {
      this.page = val;
      this.getList(this.page);
    },
  },
};
</script>

<style lang="scss" scoped>

.paginationbox {
  width: 100%;
  //position: absolute;
  bottom: 30px;
  left: 0;
}
.status {
  display: inline-block;
  width: 56px;
  height: 24px;
  border-radius: 6px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 13px;
  color: #ffffff;
  text-align: center;
  line-height: 24px;
}
.sicon1 {
  background: #ff4d4f;
}
.sicon2 {
  background: #0091ff;
}
.btn_box {
  display: flex;
  margin-top: 30px;
}
.pagination_box {
  text-align: right;
  margin-top: 50px;
}
.goods_name {
  line-height: 20px;
  font-size: 16px;
  font-weight: 600;
  color: #000;
}
.tname {
  font-size: 14px;
  font-weight: 400;
  color: #000;
  margin-top: 15px;
}
.inputtime {
  font-size: 12px;
  font-weight: 400;
  color: #969696;
  margin-top: 10px;
  line-height: 18px;
}
.p_footer {
  display: flex;

  .p_item_footer {
    width: 50%;
    height: 64px;
    line-height: 64px;
    text-align: center;
  }
  .p_item_footer:nth-child(1) {
    border-right: 2px solid #eee;
  }
}
.header_box {
  width: 100%;
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 40px;
}
.create-btn {
  width: 148px;
  height: 42px;
  color: #fff;
  font-size: 19px;
  font-weight: 500;
  cursor: pointer;
  line-height: 42px;
  text-align: center;
  background: #1677ff;
  border-radius: 4px;
  &:hover {
    text-decoration: underline;
  }
}
.content-type {
  padding-bottom: 35px;
  .main-title {
    width: 100%;
    margin-top: 40px;
  }
}
.p_list {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  // background: #fff;
  // border-radius: 8px;
  padding: 20px 0 0;
  box-sizing: border-box;
}
.p_item {
  width: -webkit-calc((100% - 20px * 4)/ 4);
  width: calc((100% - 20px * 4) / 4);
  margin: 0 20px 20px 0;
  background: #fff;
  border-radius: 8px;
  padding: 20px 0 0;
  box-sizing: border-box;
}
.p_item_top {
  padding: 0 20px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .select_box {
    width: 80px;
  }
}
.p_item_scoend {
  margin-top: 10px;
  padding: 0 15px 15px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  border-bottom: 2px solid #eee;
  img {
    width: 100px;
    height: 100px;
    border-radius: 10px;
    margin-right: 20px;
  }
}
.search-wrap {
  width: 100%;
  background: #fff;
  border-radius: 8px;
  margin-top: 50px;
  align-items: center;
  justify-content: space-between;
  padding: 20px;
  box-sizing: border-box;

  margin-bottom: 20px;
  .search-input {
    align-items: center;
  }
  .search-input .search-btn {
    width: 130px;
    height: 42px;

    cursor: pointer;
    font-size: 19px;
    margin-right: 11px;
    line-height: 42px;
    text-align: center;
    // background: #2c2c2e;
    border-radius: 4px;
    &:hover {
      text-decoration: underline;
    }
  }
  .search {
    background: #008dff;
    color: #fff;
  }
  .reset {
    color: #2690e6;
    border: 1px solid #008dff;
    margin-left: 11px;
  }
}
</style>
<style lang="scss">
.search-wrap {
  .search-input {
    .el-input {
      font-size: 14px;
      width: 40%;
    }
    .el-input__inner {
      height: 42px;
      line-height: 42px;
      border-radius: 4px;
    }
  }
}
.invitation-table .el-pagination {
  margin-top: 30px;
  text-align: center;
  .el-pager li,
  .el-pagination__total {
    font-size: 14px;
  }
  .el-pagination__jump {
    font-size: 14px;
  }
}
.my-table {
  color: #888;
  font-size: 18px;
  // margin-top: 30px;
}
.my-table tbody td,
.my-table tbody th {
  height: 70px;
  padding: 5px 0;
  box-sizing: border-box;
}
.my-table tbody th,
.my-table tbody tr {
  background: #f2f6fb;
}
.my-table tbody tr.is-new {
  color: #0e0e0e;
}
.check-btn {
  color: #1677ff;
  cursor: pointer;
  margin-left: 20px;
}
.check-btn:hover {
  text-decoration: underline;
}
.check-del {
  color: #ff4d4f;
}
.my-table tbody tr td .check-btn {
  color: #1677ff;
  cursor: pointer;
}
.my-table tbody tr td .check-btn:hover {
  text-decoration: underline;
}
.my-table tbody tr td .check-btn.check-del {
  color: #ff4d4f;
}
.el-table--striped .el-table__body tr.el-table__row--striped td {
  background: #fff;
}
.el-table td,
.el-table th.is-leaf {
  border-bottom: 0 none;
}
/* 表格最外层边框-底部边框 */
.el-table--border::after,
.el-table--group::after {
  width: 0;
}
.my-table::before {
  width: 0;
}
.my-table tbody tr td:first-child {
  border-radius: 10px 0 0 10px;
}
.my-table tbody tr td:last-child {
  border-radius: 0 10px 10px 0;
}
@media only screen and (max-width: 1366px) {
  .p_list {
    width: 100% !important;
  }
  .p_item {
    width: -webkit-calc((100% - 20px * 3)/ 3) !important;
    width: calc((100% - 20px * 3) / 3) !important;
    margin: 0 20px 20px 0 !important;
    background: #fff;
    border-radius: 8px;
    padding: 20px 0 0;
    box-sizing: border-box;
  }
}
@media only screen and (max-width: 1280px) {
  .p_list {
    width: 100% !important;
  }
  .p_item {
    width: -webkit-calc((100% - 15px * 2)/ 2) !important;
    width: calc((100% - 15px * 2) / 2) !important;
    margin: 0 15px 15px 0 !important;
    background: #fff;
    border-radius: 8px;
    padding: 20px 0 0;
    box-sizing: border-box;
  }
}
@media only screen and (max-width: 1200px) {
  .p_list {
    width: 100% !important;
  }
  .p_item {
    width: -webkit-calc((100% - 15px * 2)/ 2) !important;
    width: calc((100% - 15px * 2) / 2) !important;
    //   margin: 0 15px 15px 0 !important;
    background: #fff;
    border-radius: 8px;
    padding: 20px 0 0;
    box-sizing: border-box;
  }
}
@media only screen and (max-width: 767px) {
  .content .el-button[data-v-3c9f3c10] {
    position: initial !important;
  }
  .el-pagination {
    padding: 2px 23px !important;
  }
  .p_item_footer {
    height: 54px !important;
    line-height: 54px !important;
    font-size: 14px !important;
  }
  .tname {
    margin-top: 10px !important;
  }
  .inputtime {
    margin-top: 10px !important;
  }
  .p_item_scoend img {
    width: 80px !important;
    height: 81px !important;
    margin-right: 15px !important;
  }
  .create-btn {
    width: 120px !important;
    height: 40px !important;
    font-size: 15px !important;
  }
  .search-wrap .search-input .search-btn {
    width: 130px !important;
    height: 40px !important;
    font-size: 15px !important;
  }
  .content {
    padding: 30px 0 130px 0;
  }
  .p_item {
    width: 100% !important;
    margin: 0 auto 20px !important;
  }
  .p_list {
    width: 100% !important;
    margin-left: 0 !important;
    display: inline-block !important;
  }
  .search-wrap {
    width: 92% !important;
    // margin:auto !important;
    margin-top: 0 !important;
  }
  .invitation-table {
    width: 92% !important;
  }
  .search-input {
    flex-wrap: wrap;
  }
  .el-input__inner {
    // width: 90% !important;
    margin: 20px 0;
  }
  .main-sub {
    width: 100%;
    padding-bottom: 8px !important;
  }
  .header_box {
    padding-bottom: 50px !important;
  }
  .create-btn {
    margin-bottom: 20px !important;
    position: absolute;
    right: 24px;
    bottom: 0;
  }
  .search-wrap .search-input .el-input {
    width: 100% !important;
  }
}
</style>
<style>
.el-dialog {
  width: 35%;
}
@media only screen and (max-width: 767px) {
  .el-pagination {
    padding: 2px 23px !important;
  }
  .el-dialog {
    width: 100%;
  }
  .el-message-box {
    width: 350px !important;
  }
}
</style>

